import { ColumnHeader } from '@src/components/Table/components';
import { SortDirection } from '@src/types/common';
import { cleanNumberDisplay } from '@src/utilities/currency';
import dayjs from 'dayjs';
import { TFunction } from 'i18next';

interface RenderColumnsProps {
  t: TFunction;
  sorterState?: {
    sortBy: string | null;
    sortOrder: SortDirection | null;
    onSortChange: (columnKey: string, order: SortDirection | null) => void;
  };
}

export function RenderColumns({ t, sorterState }: RenderColumnsProps) {
  const baseColumns = [
    {
      key: 'payoutDate',
      dataIndex: 'payoutDate',
      title: t('pages.affiliate.payouts.dataTable.payoutDate'),
      sortable: false,
      render: (_, item) => {
        return dayjs(item.payoutDate).format('MM/DD/YYYY - HH:mm A');
      },
    },
    {
      key: 'amount',
      dataIndex: 'amount',
      title: t('pages.affiliate.payouts.dataTable.amount'),
      render: (_, item) => {
        return cleanNumberDisplay(item.amount);
      },
    },
    {
      key: 'currency',
      dataIndex: 'currency',
      title: t('pages.affiliate.payouts.dataTable.currency'),
    },
  ];

  const equalWidth = `${100 / baseColumns.length}%`;

  const enhancedColumns = [
    ...baseColumns.map((col) => ({
      ...col,
      width: equalWidth,
      title: (
        <ColumnHeader
          title={col.title}
          columnKey={col.dataIndex}
          sortable={!!col.sortable}
          sortOrder={
            sorterState?.sortBy === col.key ? sorterState.sortOrder : null
          }
          onSortChange={(order) => sorterState?.onSortChange(col.key, order)}
        />
      ),
    })),
  ];

  return enhancedColumns;
}
